import { render, staticRenderFns } from "./WebHostingDomainAlias.vue?vue&type=template&id=6d3555a9&scoped=true&"
import script from "./WebHostingDomainAlias.vue?vue&type=script&lang=js&"
export * from "./WebHostingDomainAlias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3555a9",
  null
  
)

export default component.exports